import axios from "axios";
import { apiUrl } from "../../constants/config";
import { apiCreditWiinUrl } from "../../constants/config";
import { store } from "../Store";
export default {
  state: {
    loadingAssuranceList: [],
    ListeAllProjet: [],
    IdClientProjet: "",
    DetailsCoutTotale: {
      cout_prets: {
        pretPrincipal: {
          pret_name: null,
          cout_interet: null,
          cout_assurance: null,
        },
      },
      cout_supp: {
        cout_garanti: null,
        cout_frais_dossier: null,
        cout_courtage: null,
        cout_total: null,
      },
    },
    coemprunteur: false,
    DetailsGarantie: [],
    liste_avis_valeur: [],
    totalAncien: 0,
    DetailsAncienBien: [],
    ListeBienAncien: [],
    prets: [],
    Location: [],
    ListeResultRechBienNeuf: [],
    ListeProgramsBienNeuf: [],
    succes_result_bien_neuf: [],
    error_result_bien_neuf: [],
    totalRowRech: 0,
    totalRowRechBienNeuf: 0,
    totalBiens: 0,
    totalProgrammes: 0,
    Localisation: "",
    residence: null,
    listePromoteurs: [],
    listeProgrammes: [],
    projectFilters: [],
    Habiter: null,
    Investir: null,
    Pinel: null,
    Lmnp: null,
    LmnpAmort: null,
    LmnpCensi: null,
    minBudgetPT: null,
    maxBudgetPT: null,
    minBudgetPM: null,
    maxBudgetPM: null,
    minSurfaceHab: null,
    maxSurfaceHab: null,
    locationProject: null,
    promoteur: null,
    programme: null,
    valueType: null,
    valueTypologie: null,
    etage: null,
    exposition: null,
    valueCommodite: null,
    Livraison: null,
    commission: null,
    zFiscale: null,
    valueDisponibiliteLots: null,
    Bien: null,
    statusBien: null,
    bienPriceMin: -1,
    bienPriceMedian: -1,
    bienPriceMax: -1,
    projectCost: {},
    bankIdents: [],
    propostionsValidesBasic: [],
    propositionsInvalidesBasic: [],
    doneBasic: [],
    loadingbankBasic: "",
    loadingValueBasic: 10,
    DetailsFaisabilite: [],
    AnnonceursList: [],
    errorMessage: null,
  },
  getters: {
    loadingAssuranceList: (state) => state.loadingAssuranceList,
    ListeAllProjet: (state) => state.ListeAllProjet,
    IdClientProjet: (state) => state.IdClientProjet,
    DetailsCoutTotale: (state) => state.DetailsCoutTotale,
    coemprunteur: (state) => state.coemprunteur,
    DetailsGarantie: (state) => state.DetailsGarantie,
    liste_avis_valeur: (state) => state.liste_avis_valeur,
    simulationsDetails: (state) => state.simulationsDetails,
    totalAncien: (state) => state.totalAncien,
    DetailsAncienBien: (state) => state.DetailsAncienBien,
    ListeBienAncien: (state) => state.ListeBienAncien,
    getPrets: (state) => state.prets,
    Location: (state) => state.Location,
    Localisation: (state) => state.Localisation,
    ListeResultRechBienNeuf: (state) => state.ListeResultRechBienNeuf,
    ListeProgramsBienNeuf: (state) => state.ListeProgramsBienNeuf,
    totalRowRech: (state) => state.totalRowRech,
    totalRowRechBienNeuf: (state) => state.totalRowRechBienNeuf,
    totalBiens: (state) => state.totalBiens,
    totalProgrammes: (state) => state.totalProgrammes,
    succes_result_bien_neuf: (state) => state.succes_result_bien_neuf,
    error_result_bien_neuf: (state) => state.error_result_bien_neuf,
    residence: (state) => state.residence,
    listePromoteurs: (state) => state.listePromoteurs,
    listeProgrammes: (state) => state.listeProgrammes,
    projectFilters: (state) => state.projectFilters,
    Habiter: (state) => state.Habiter,
    Investir: (state) => state.Investir,
    Pinel: (state) => state.Pinel,
    Lmnp: (state) => state.Lmnp,
    LmnpAmort: (state) => state.LmnpAmort,
    LmnpCensi: (state) => state.LmnpCensi,
    minBudgetPT: (state) => state.minBudgetPT,
    maxBudgetPT: (state) => state.maxBudgetPT,
    minBudgetPM: (state) => state.minBudgetPM,
    maxBudgetPM: (state) => state.maxBudgetPM,
    minSurfaceHab: (state) => state.minSurfaceHab,
    maxSurfaceHab: (state) => state.maxSurfaceHab,
    locationProject: (state) => state.locationProject,
    promoteur: (state) => state.promoteur,
    programme: (state) => state.programme,
    valueType: (state) => state.valueType,
    valueTypologie: (state) => state.valueTypologie,
    etage: (state) => state.etage,
    exposition: (state) => state.exposition,
    valueCommodite: (state) => state.valueCommodite,
    Livraison: (state) => state.Livraison,
    commission: (state) => state.commission,
    zFiscale: (state) => state.zFiscale,
    valueDisponibiliteLots: (state) => state.valueDisponibiliteLots,
    Bien: (state) => state.Bien,
    statusBien: (state) => state.statusBien,
    bienPriceMin: (state) => state.bienPriceMin,
    bienPriceMedian: (state) => state.bienPriceMedian,
    bienPriceMax: (state) => state.bienPriceMax,
    projectCost: (state) => state.projectCost,
    bankIdents: (state) => state.bankIdents,
    propostionsValidesBasic: (state) => state.propostionsValidesBasic,
    propositionsInvalidesBasic: (state) => state.propositionsInvalidesBasic,
    doneBasic: (state) => state.doneBasic,
    loadingbankBasic: (state) => state.loadingbankBasic,
    loadingValueBasic: (state) => state.loadingValueBasic,
    DetailsFaisabilite: (state) => state.DetailsFaisabilite,
    AnnonceursList: (state) => state.AnnonceursList,
    errorMessage: (state) => state.errorMessage,
  },
  mutations: {
    setUpdatedAssuranceActionKey(state) {
      return (state.updatedAssuranceActionKey = Math.floor(
        Math.random() * 100000
      ));
    },
    DO_NOTHING() {},
    ADD_PRET(state, payload) {
      state.prets = payload;
    },
    getCoemprunteur(state, payload) {
      state.coemprunteur = payload.coemprunteur;
    },
    setLocalisation(state, payload) {
      state.Localisation = payload.Localisation;
    },
    setResidence(state, payload) {
      state.residence = payload.residence;
    },
    getlistePromoteurs(state, payload) {
      state.listePromoteurs = payload.listePromoteurs;
    },
    getlisteProgrammes(state, payload) {
      state.listeProgrammes = payload.listeProgrammes;
    },
    getProjectFilters(state, payload) {
      state.projectFilters = payload.projectFilters;
    },
    setBien(state, payload) {
      state.Bien = payload.Bien;
    },
    setbienPriceMin(state, payload) {
      state.bienPriceMin = payload.bienPriceMin;
    },
    setbienPriceMedian(state, payload) {
      state.bienPriceMedian = payload.bienPriceMedian;
    },
    setbienPriceMax(state, payload) {
      state.bienPriceMax = payload.bienPriceMax;
    },
  },
  actions: {
    getCurrentProject({ commit, state }) {
      let indexCurrentProject = 0;
      if (localStorage.getItem("CurrentIndexProjet") == null) {
        indexCurrentProject = 0;
      } else {
        indexCurrentProject = localStorage.getItem("CurrentIndexProjet");
        indexCurrentProject = 0;
        localStorage.setItem("CurrentIndexProjet", 0);
      }
      let currentIdProject = localStorage.getItem("project_id");
      return axios
        .get(apiCreditWiinUrl + "/" + "/api/simulations/" + currentIdProject, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Authorization: "Bearer " + localStorage.getItem("EmpToken"),
          },
        })
        .then((response) => {
          state.ListeAllProjet = [];
          var data = response.data.data;
          state.ListeAllProjet[indexCurrentProject] = data;
        })
        .catch((e) => {
          // Vue.$notify('error filled', 'Erreur', e, {
          //     duration: 3000,
          //     permanent: false
          // });
          //this.state.loading=false;
        });
    },

    async getInformationClientForCurrentProjet(
      { commit, state },
      { idPorjet }
    ) {
      //store.state.loading = true;
      state.IdClientProjet = null;
      state.IdEmprunteurProjet = null;
      state.IdCoemprunteurProjet = null;
      state.customersList = [];

      return await axios
        .get(
          apiCreditWiinUrl + "/" + "/api/simulation/" + idPorjet + "/customers",
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          state.ContactSimulation = [];
          state.ContactSimulationCredit = [];
          state.customersList = [];
          const data = response.data.data;
          var FullNameEmp = "";
          var FullNameCoEmp = "";
          state.emp_societe = null;
          state.CoempExiste = false;
          // const selectSci={value:'sci',text:'SCI Propriétaire'}
          // state.ContactSimulationCredit.push(selectSci)
          data.forEach(function(item) {
            console.log("item contact=", item);
            state.customersList.push(item);
            if (item.costumer_type == "emp") {
              state.emp_societe = item.id;
              localStorage.setItem("CurrentEmprunteurProjet", item.id);
              state.IdClientProjet = item.id;
              FullNameEmp = item.first_name + " " + item.last_name;
              const select = {
                value: "emp",
                text: FullNameEmp,
              };
              state.ContactSimulation.push(select);
              state.ContactSimulationCredit.push(select);

              // console.log('name=', item.first_name);
            } else {
              state.CoempExiste = true;
              FullNameCoEmp = item.first_name + " " + item.last_name;
              const select = {
                value: "coemp",
                text: FullNameCoEmp,
              };
              state.ContactSimulation.push(select);
              state.ContactSimulationCredit.push(select);

              state.IdCoemprunteurProjet = item.id;
              localStorage.setItem("CurrentCoEmprunteurProjet", item.id);
            }
          });
          if (state.CoempExiste == true) {
            const select2 = {
              value: "common",
              text: FullNameEmp + " + " + FullNameCoEmp,
            };
            state.ContactSimulation.push(select2);
            state.ContactSimulationCredit.push(select2);
          }
        })
        .catch((e) => {
          // Vue.$notify(
          //     'error filled',
          //     'Erreur',
          //     'Erreur est survenue lors de mise à jour', {
          //         duration: 3000,
          //         permanent: false
          //     }
          // );
        });
    },

    resetAssuranceQuotite({ commit, state }, { id }) {
      this.state.loading = true;
      return axios
        .get(apiCreditWiinUrl + "/" + "/api/simulations/" + id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Authorization: "Bearer " + localStorage.getItem("EmpToken"),
          },
        })
        .then((response) => {
          commit("setSimulationCustomers", response.data.data);
        });
    },

    UpdateAssuranceEmpruteur({ commit, state }, { data, idClient }) {
      for (var propName in data) {
        if (
          (data[propName] === null || data[propName] === undefined) &&
          propName != "taux_chargement" &&
            propName != "franchise" &&
            propName !== "garantie_assure"
        ) {
          data[propName] = false;
        }
        if (
          (data[propName] === null || data[propName] === undefined) &&
          propName == "taux_chargement"
        ) {
          delete data[propName];
        }
        if (
          (data[propName] === null || data[propName] === undefined) &&
          propName == "franchise"
        ) {
          delete data[propName];
        }
        if (
          (data[propName] === null || data[propName] === undefined) &&
          propName == "garantie_assure"
        ) {
          delete data[propName];
        }
      }
      return axios
        .post(
          apiCreditWiinUrl + "/" + "api/customer/" + idClient + "/assurance",
          data,
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          this.getListeAllAssurance({ commit, state }, { idClient: idClient });
        })
        .catch((e) => {
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    },

    getListeAllAssurance({ commit, state }, { idClient }) {
      state.Assurance = [];
      return axios
        .get(
          apiCreditWiinUrl + "/" + "api/customer/" + idClient + "/assurance",
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          const data = response.data.data;
          state.Assurance = data;
          return data;
        })
        .catch((e) => {
          //Vue.$notify('error filled', 'Erreur', e, { duration: 3000, permanent: false });
        });
    },

    DetailsFaisabiliteProposition({ commit, state }, { data }) {
      state.DetailsFaisabilite = [];
      state.currentBanque = data.bank.data.bankName;
      // console.log('ici bank name=', data)
      axios
        .get(
          apiCreditWiinUrl + "/api/proposition/" + data.id + "/feasibility",
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          state.DetailsFaisabilite = [];
          state.DetailsFaisabilite = response.data.data;
        })
        .catch((e) => {});
    },

    DetailsCoutTotaleProjet({ commit, state }, { data }) {
      state.DetailsCoutTotale = [];
      state.currentBanque = data.bank.data.bankName;
      // console.log('ici bank name=', data)
      axios
        .get(
          apiCreditWiinUrl +
            "/" +
            "api/proposition/" +
            data.id +
            "/detail-calc/cout-projet",
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          //    console.log('ici detail cout=', response)
          state.DetailsCoutTotale = [];
          state.DetailsCoutTotale = response.data;
        })
        .catch((e) => {});
    },

    generatePropositionsAssurancePersoWithLoader(
      { commit, state, actions },
      {
        index,
        type,
        bank_ident,
        ta,
        ta_coemp,
        ti,
        ti_relais,
        isRelais,
        duration,
      }
    ) {
      let i = 0;
      var currentIdProjet = localStorage.getItem("project_id");
      return axios
        .post(
          apiCreditWiinUrl +
            "/" +
            "api/simulations/" +
            localStorage.getItem("project_id") +
            "/propositions-perso-assurance",
          {
            type: type,
            bank_ident: bank_ident,
            ta: ta,
            ta_coemp: ta_coemp,
            ti: ti,
            ti_relais: ti_relais,
            isRelais: isRelais,
            costs: state.projectCost,
            duration: duration,
          },
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          let data = response.data.data;
          let is_valid = data.is_valid;
          if (is_valid == true) {
            state.propostionsValidesBasic.splice(index, 1, data);
          } else {
            state.propositionsInvalidesBasic.splice(index, 1, data);
          }
        })
        .catch((e) => {});
    },

    generatePropositionsPersoWithLoader(
      { commit, state, actions },
      {
        index,
        type,
        bank_ident,
        ta,
        ta_coemp,
        ti,
        ti_relais,
        isRelais,
        duration,
      }
    ) {
      let i = 0;
      var currentIdProjet = localStorage.getItem("project_id");
      return axios
        .post(
          apiCreditWiinUrl +
            "/" +
            "api/simulations/" +
            localStorage.getItem("project_id") +
            "/propositions-perso",
          {
            type: type,
            bank_ident: bank_ident,
            ta: ta,
            ta_coemp: ta_coemp,
            ti: ti,
            ti_relais: ti_relais,
            isRelais: isRelais,
            costs: state.projectCost,
            duration: duration,
          },
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("authToken"),
            },
          }
        )
        .then((response) => {
          //actions.getPropositions({ commit, state }, { type: type })
          ///store.dispatch('getPropositions',{type:type});

          console.log("response", response.data.data);
          console.log("index", index);
          let data = response.data.data;
          let is_valid = data.is_valid;
          if (is_valid == true) {
            if (type == "contre_ptz") {
              state.propositionsValides.splice(index, 1, data);
            } else if (type == "contre") {
              state.propositionsValidesAncien.splice(index, 1, data);
            } else if (type == "basic") {
              state.propostionsValidesBasic.splice(index, 1, data);
            }
          } else {
            if (type == "contre_ptz") {
              state.propositionsInvalides.splice(index, 1, data);
            } else if (type == "contre") {
              state.propositionsInValidesAncien.splice(index, 1, data);
            } else if (type == "basic") {
              state.propositionsInvalidesBasic.splice(index, 1, data);
            }
          }

          // axios.get(apiCreditWiinUrl + "/"+"api/simulations/" + localStorage.getItem("project_id") + "/propositions",
          //   { type: type, bank_ident: bank_ident, isFromImmoWiin: true, project_id: currentIdProjet, costs: state.projectCost },
          //   { headers: { 'X-Requested-With': 'XMLHttpRequest', 'Authorization': 'Bearer ' + localStorage.getItem("authToken") } }
          // ).then((response) => {
          //   //  console.log('im here for proposition=',response)
          //     state.propostionsValidesBasic = [];
          //     state.propositionsInvalidesBasic = [];
          //     const data = response.data.data;
          //     // if (data) {
          //     //     if (type == 'basic') {

          //             if (type == 'contre_ptz') {

          //                 data.forEach(function (item) {
          //                     if (item.is_valid == true) {
          //                         state.propositionsValides.push(item)
          //                     }
          //                     else if (item.is_valid == false) {
          //                         state.propositionsInvalides.push(item)
          //                     }
          //                 })

          //             }
          //             else if (type == 'contre') {
          //                 data.forEach(function (item) {
          //                     if (item.is_valid == true) {
          //                         state.propositionsValidesAncien.push(item)
          //                     }
          //                     else if (item.is_valid == false) {
          //                         state.propositionsInValidesAncien.push(item)
          //                     }
          //                 })

          //             }
          //             else if (type == 'basic') {
          //                 data.forEach(function (item) {
          //                     if (item.is_valid == true) {
          //                         state.propostionsValidesBasic.push(item)
          //                     }
          //                     else if (item.is_valid == false) {
          //                         state.propositionsInvalidesBasic.push(item)
          //                     }
          //                 })
          //             }

          //     //     }
          //     // }
          //   }).catch((e) => {

          //   });
        })
        .catch((e) => {});
    },

    getFrais({ commit, state }, { idSimulation, type }) {
      state.projectCost = [];
      localStorage.removeItem("projectCosts");
      //if(state.ListeFrais.length==0){
      return axios
        .get(
          apiCreditWiinUrl + "/" + "/api/simulation/" + idSimulation + "/costs",
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          const data = response.data.data;
          for (var propName in data) {
            if (data[propName] === null || data[propName] === undefined) {
              data[propName] = 0;
            }
          }

          let result = 0;

          if (type == 1) {
            result =
              parseFloat(data.terrain) +
              parseFloat(data.viabilisation) +
              parseFloat(data.etablissement) +
              parseFloat(data.agence) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 1) {
            result =
              parseFloat(data.viabilisation) +
              parseFloat(data.logemet) +
              parseFloat(data.traveaux) +
              parseFloat(data.mobilier) +
              parseFloat(data.etablissement) +
              parseFloat(data.expertise) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 2) {
            result =
              parseFloat(data.terrain) +
              parseFloat(data.viabilisation) +
              parseFloat(data.logemet) +
              parseFloat(data.traveaux) +
              parseFloat(data.mobilier) +
              parseFloat(data.etablissement) +
              parseFloat(data.expertise) +
              parseFloat(data.agence) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) -
              parseFloat(data.apport);
          } else if (type == 3) {
            result =
              parseFloat(data.terrain) +
              parseFloat(data.viabilisation) +
              parseFloat(data.logemet) +
              parseFloat(data.traveaux) +
              parseFloat(data.mobilier) +
              parseFloat(data.etablissement) +
              parseFloat(data.expertise) +
              parseFloat(data.agence) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 4) {
            result =
              parseFloat(data.logemet) +
              parseFloat(data.traveaux) +
              parseFloat(data.mobilier) +
              parseFloat(data.etablissement) +
              parseFloat(data.agence) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 5) {
            result =
              parseFloat(data.logemet) +
              parseFloat(data.traveaux) +
              parseFloat(data.mobilier) +
              // parseFloat(data.etablissement) +
              parseFloat(data.agence) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 6) {
            result =
              parseFloat(data.logemet) +
              parseFloat(data.mobilier) +
              parseFloat(data.etablissement) +
              parseFloat(data.expertise) +
              parseFloat(data.agence) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 7) {
            result =
              parseFloat(data.logemet) +
              parseFloat(data.traveaux) +
              parseFloat(data.mobilier ? data.mobilier : 0) +
              parseFloat(data.etablissement) +
              parseFloat(data.expertise) +
              parseFloat(data.agence) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 8) {
            result =
              parseFloat(data.traveaux) +
              parseFloat(data.mobilier) +
              parseFloat(data.etablissement) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 9) {
            result =
              parseFloat(data.traveaux) +
              parseFloat(data.etablissement) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 10 || type == 11) {
            result =
              parseFloat(data.traveaux) +
              parseFloat(data.etablissement) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 12) {
            result =
              parseFloat(data.etablissement) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 13) {
            result =
              parseFloat(data.soulte) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 14) {
            result =
              parseFloat(data.soulte) +
              parseFloat(data.traveaux) +
              parseFloat(data.crd_refinance) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 15) {
            result =
              parseFloat(data.etablissement) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          } else if (type == 16 || type == 17) {
            result =
              parseFloat(data.tresorie) +
              parseFloat(data.pret_rachete) +
              parseFloat(data.decouvert_blanc) +
              parseFloat(data.traveaux) +
              parseFloat(data.indemite_ra) +
              parseFloat(data.fr_leve_hypo) +
              parseFloat(data.notaire) +
              parseFloat(data.courtage) -
              parseFloat(data.apport);
          }
          data["couttotal"] = Math.round(result);

          state.projectCost = data;
          localStorage.setItem(
            "projectCosts",
            JSON.stringify(state.projectCost)
          );
        })
        .catch((e) => {});
    },

    UpdateFraisProjet({ commit, state }, { data, idSimulation }) {
      data["couttotal"] = this.getMontantTotaleProjet(
        { commit, state },
        { data: data, type: false }
      );
      // data['notaire'] = actions.getMontantFraisNotaire(
      //   { commit, state },
      //   { data: data }
      // );
      state.ListeFrais = data;

      axios
        .post(
          apiCreditWiinUrl + "/" + "/api/simulation/" + idSimulation + "/costs",
          data,
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("authToken"),
            },
          }
        )
        .then((response) => {
          this.getFrais({ idSimulation: idSimulation });
        })
        .catch((e) => {
          // Vue.$notify('error filled', 'Erreur', e, {
          //   duration: 3000,
          //   permanent: false
          // });
        });
    },

    DetailsGarantieProposition({ commit, state }, { data }) {
      console.log("Details Garantie Data: ", data);
      (state.DetailsGarantie = []),
        axios
          .get(
            apiCreditWiinUrl +
              "/" +
              "api/proposition/" +
              data.id +
              "/detail-calc/list-garanties",
            {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                Authorization: "Bearer " + localStorage.getItem("EmpToken"),
              },
            }
          )
          .then((response) => {
            console.log("Details Garantie Reponse: ", response);
            (state.DetailsGarantie = []),
              (state.DetailsGarantie = response.data.data);
          })
          .catch((e) => {
            console.log("Error: ", e);
          });
    },

    async getDetailsSim({ commit, state }) {
      try {
        const response = await axios.get(
          apiCreditWiinUrl +
            "/" +
            "api/simulations/" +
            localStorage.getItem("project_id"),
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        );
        // console.log(response.data.data);
        state.simulationsDetails = response.data.data;
        console.log(state.simulationsDetails);
      } catch (e) {
        console.log(e);
      }
    },

    async fastUpdateSimulation(
      { commit, state },
      { duration, mensualite_souhaite, ti_souhaite, ta_souhaite }
    ) {
      try {
        const response = await axios.post(
          apiCreditWiinUrl +
            "/" +
            "api/simulation/" +
            localStorage.getItem("project_id") +
            "/fast-update",
          {
            duration: duration,
            mensualite_souhaite: mensualite_souhaite,
            ti_souhaite: ti_souhaite,
            ta_souhaite: ta_souhaite,
          },
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        );
        this.getDetailsSim({ commit, state });
      } catch (e) {
        console.log(e);
      }
    },

    getProjectFilters({ commit, state }, { project_id }) {
      state.projectFilters = [];
      state.Habiter = null;
      state.Investir = null;
      state.Pinel = null;
      state.Lmnp = null;
      state.LmnpAmort = null;
      state.LmnpCensi = null;
      state.minBudgetPT = null;
      state.maxBudgetPT = null;
      state.minBudgetPM = null;
      state.maxBudgetPM = null;
      state.minSurfaceHab = null;
      state.maxSurfaceHab = null;
      state.locationProject = null;
      state.promoteur = null;
      state.programme = null;
      state.valueType = null;
      state.valueTypologie = null;
      state.etage = null;
      state.exposition = null;
      state.valueCommodite = null;
      state.Livraison = null;
      state.commission = null;
      state.zFiscale = null;
      state.valueDisponibiliteLots = null;
      return axios
        .get(apiUrl + "/api/projectfiltersall?project_id=" + project_id)
        .then((res) => {
          state.projectFilters = res.data;
          if (
            res.data.body != null &&
            res.data.body.annonceursSelectedList == undefined
          ) {
            state.projectFilters.body.annonceursSelectedList = [];
          }
          // state.Habiter = res.data.habiter
          // state.Investir = res.data.investir
          // state.Pinel = res.data.pinel
          // state.Lmnp = res.data.lmnp
          // state.LmnpAmort = res.data.lmnpAmort
          // state.LmnpCensi = res.data.lmnpCensi
          // state.minBudgetPT = res.data.minBudgetPT
          // state.maxBudgetPT = res.data.maxBudgetPT
          // state.minBudgetPM = res.data.minBudgetPM
          // state.maxBudgetPM = res.data.maxBudgetPM
          // state.minSurfaceHab = res.data.minSurfaceHab
          // state.maxSurfaceHab = res.data.maxSurfaceHab
          state.locationProject = state.projectFilters.locationProjet;
          // state.promoteur = res.data.promoteur
          // state.programme = res.data.programme
          // state.valueType = res.data.valueType
          // state.valueTypologie = res.data.valueTypologie
          // state.etage = res.data.etage
          // state.exposition = res.data.exposition
          // state.valueCommodite = res.data.valueCommodite
          // state.Livraison = res.data.livraison
          // state.commission = res.data.commission
          // state.zFiscale = res.data.zFiscale
          // state.valueDisponibiliteLots = res.data.valueDisponibiliteLots
        })
        .catch((error) => {});
    },

    // getListAnnonceurs({ commit, state }) {
    //   state.AnnonceursList = [];
    //   return axios
    //     .get(apiUrl + "/api/annonceurs")
    //     .then((res) => {
    //       state.AnnonceursList = res.data;
    //     })
    //     .catch((error) => {});
    // },

    setProjectFilters(
      { commit, state },
      {
        project_id,
        habiter,
        ancien,
        investir,
        pinel,
        lmnp,
        lmnpAmort,
        lmnpCensi,
        typeResidence,
        minBudgetPT,
        maxBudgetPT,
        minBudgetPM,
        maxBudgetPM,
        minSurfaceHab,
        maxSurfaceHab,
        locationProjet,
        promoteur,
        programme,
        valueType,
        valueTypologie,
        etage,
        exposition,
        valueCommodite,
        Livraison,
        commission,
        zFiscale,
        valueDisponibiliteLots,
      }
    ) {
      var formData = {};
      formData.project_id = parseInt(project_id);
      formData.habiter = habiter == true ? "Habiter" : "";
      formData.ancien = ancien == true ? "Ancien" : "";
      formData.investir = investir == true ? "Investir" : "";
      formData.pinel = pinel == true ? "Pinel" : "";
      formData.lmnp = lmnp == true ? "LMNP" : "";
      formData.lmnpAmort = lmnpAmort == true ? "LMNP Amort" : "";
      formData.lmnpCensi = lmnpCensi == true ? "LMNP Censi" : "";

      if (typeResidence > 0) formData.typeResidence = typeResidence;
      formData.locationProjet =
        locationProjet != null && locationProjet.length > 0
          ? locationProjet
          : "";

      formData.minBudgetPT =
        minBudgetPT != null && minBudgetPT > 0 ? minBudgetPT : "";
      formData.maxBudgetPT =
        maxBudgetPT != null && maxBudgetPT > 0 ? maxBudgetPT : "";
      formData.minBudgetPM =
        minBudgetPM != null && minBudgetPM > 0 ? minBudgetPM : "";
      formData.maxBudgetPM =
        maxBudgetPM != null && maxBudgetPM > 0 ? maxBudgetPM : "";

      formData.valueType = valueType != null ? valueType : "";
      formData.valueTypologie =
        valueTypologie != null && valueTypologie.length > 0
          ? valueTypologie
          : "";
      formData.minSurfaceHab =
        minSurfaceHab != null && minSurfaceHab > 0 ? minSurfaceHab : "";
      formData.maxSurfaceHab =
        maxSurfaceHab != null && maxSurfaceHab > 0 ? maxSurfaceHab : "";

      formData.etage = etage != null && etage > 0 ? etage : 0;

      if (exposition != null) formData.exposition = exposition;
      if (valueCommodite != null) formData.valueCommodite = valueCommodite;

      formData.livraison = Livraison >= 0 ? Livraison : "";

      if (commission != null) formData.commission = commission;

      formData.zFiscale = zFiscale >= 0 ? zFiscale : "";
      if (valueDisponibiliteLots >= 0)
        formData.valueDisponibiliteLots = valueDisponibiliteLots;
      formData.promoteur =
        promoteur != null && promoteur.length > 0 ? promoteur : "";
      formData.programme =
        programme != null && programme.length > 0 ? programme : "";

      return axios
        .get(apiUrl + "/api/projectfilters", {
          headers: {
            "Content-Type": "application/json",
          },
          params: formData,
        })
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },

    deleteProjectFilter({ commit, state }, { project_id }) {
      return axios
        .post(apiUrl + "/api/deleteprojectfilter?project_id=" + project_id)
        .then((res) => {})
        .catch((err) => {});
    },

    rechBienNeufWithFilter(
      { commit, state },
      {
        habiter,
        investir,
        pinel,
        lmnp,
        lmnpAmort,
        lmnpCensi,
        residence,
        typeResidence,
        location,
        cp,
        minBudgetPT,
        maxBudgetPT,
        minBudgetPM,
        maxBudgetPM,
        type,
        typologie,
        minSurfaceHab,
        maxSurfaceHab,
        critere1,
        critere2,
        critere3,
        critere4,
        critere5,
        etage,
        exposition,
        valueCommodite,
        Livraison,
        commission,
        zFiscale,
        valueDisponibiliteLots,
        promoteur,
        programme,
        perPage,
        page,
        limit,
      }
    ) {
      var formData = {};
      if (habiter == true) formData.habiter = "Habiter";
      if (investir == true) formData.investir = "Investir";
      if (pinel == true) formData.pinel = "Pinel";
      if (lmnp == true) formData.lmnp = "LMNP";
      if (lmnpAmort == true) formData.lmnpAmort = "LMNP Amort";
      if (lmnpCensi == true) formData.lmnpCensi = "LMNP Censi";
      if (residence > 0) formData.residence = residence;
      if (typeResidence > 0) formData.typeResidence = typeResidence;

      if (location != null) formData.location = location;
      if (cp != null) formData.cp = cp.zipCodes;

      if (minBudgetPT >= 0) formData.minBudgetPT = minBudgetPT;
      if (maxBudgetPT >= 0) formData.maxBudgetPT = maxBudgetPT;
      if (minBudgetPM >= 0) formData.minBudgetPM = minBudgetPM;
      if (maxBudgetPM >= 0) formData.maxBudgetPM = maxBudgetPM;

      if (type != null) formData.type = type.text;
      if (typologie != null) formData.typologie = typologie;
      if (minSurfaceHab != null) formData.minSurfaceHab = minSurfaceHab;
      if (maxSurfaceHab != null) formData.maxSurfaceHab = maxSurfaceHab;
      if (critere1 != undefined) formData.critere1 = critere1;
      if (critere2 != undefined) formData.critere2 = critere2;
      if (critere3 != undefined) formData.critere3 = critere3;
      if (critere4 != undefined) formData.critere4 = critere4;
      if (critere5 != undefined) formData.critere5 = critere5;

      if (etage > 0) formData.etage = etage;
      if (exposition != null) formData.exposition = exposition;
      if (valueCommodite != null) {
        formData.valueCommodite = valueCommodite;
      }
      if (Livraison > 0) formData.Livraison = Livraison;

      if (commission != null) formData.commission = commission;
      if (zFiscale > 0) formData.zFiscale = zFiscale;
      if (valueDisponibiliteLots >= 0)
        formData.valueDisponibiliteLots = valueDisponibiliteLots;
      if (promoteur != null) formData.promoteur = promoteur;
      if (programme != null) formData.programme = programme;

      formData.perPage = perPage;
      formData.limit = limit;
      formData.page = page;

      return axios
        .get(apiUrl + "/search-bien-neufs", {
          headers: {
            "Content-Type": "application/json",
          },
          params: formData,
        })
        .then((response) => {
          state.ListeResultRechBienNeuf = [];
          state.totalBiens = 0;
          state.totalProgrammes = 0;

          let data = response.data.data.data;
          state.totalRowRechBienNeuf = response.data.data.total;
          state.totalProgrammes = response.data.tot_prog;
          state.totalBiens = response.data.biens;

          Object.keys(data).forEach((key) => {
            state.ListeResultRechBienNeuf.push(data[key]);
          });
          state.succes_result_bien_neuf = true;
        })
        .catch((e) => {
          state.error_result_bien_neuf = true;
        });
    },

    rechBienAncienWithFilter(
      { commit, state },
      {
        habiter,
        investir,
        pinel,
        lmnp,
        lmnpAmort,
        lmnpCensi,
        residence,
        typeResidence,
        location,
        cp,
        minBudgetPT,
        maxBudgetPT,
        minBudgetPM,
        maxBudgetPM,
        type,
        typologie,
        minSurfaceHab,
        maxSurfaceHab,
        critere1,
        critere2,
        critere3,
        critere4,
        critere5,
        etage,
        exposition,
        valueCommodite,
        Livraison,
        commission,
        zFiscale,
        valueDisponibiliteLots,
        promoteur,
        programme,
        perPage,
        page,
        limit,
      }
    ) {
      var formData = {};
      if (habiter == true) formData.habiter = "Habiter";
      if (investir == true) formData.investir = "Investir";
      if (pinel == true) formData.pinel = "Pinel";
      if (lmnp == true) formData.lmnp = "LMNP";
      if (lmnpAmort == true) formData.lmnpAmort = "LMNP Amort";
      if (lmnpCensi == true) formData.lmnpCensi = "LMNP Censi";
      if (residence > 0) formData.residence = residence;
      if (typeResidence > 0) formData.typeResidence = typeResidence;

      if (location != null) formData.location = location;
      if (cp != null) formData.cp = cp.zipCodes;

      if (minBudgetPT >= 0) formData.minBudgetPT = minBudgetPT;
      if (maxBudgetPT >= 0) formData.maxBudgetPT = maxBudgetPT;
      if (minBudgetPM >= 0) formData.minBudgetPM = minBudgetPM;
      if (maxBudgetPM >= 0) formData.maxBudgetPM = maxBudgetPM;

      if (type != null) formData.type = type.text;
      if (typologie != null) formData.typologie = typologie;
      if (minSurfaceHab != null) formData.minSurfaceHab = minSurfaceHab;
      if (maxSurfaceHab != null) formData.maxSurfaceHab = maxSurfaceHab;
      if (critere1 != undefined) formData.critere1 = critere1;
      if (critere2 != undefined) formData.critere2 = critere2;
      if (critere3 != undefined) formData.critere3 = critere3;
      if (critere4 != undefined) formData.critere4 = critere4;
      if (critere5 != undefined) formData.critere5 = critere5;

      if (etage > 0) formData.etage = etage;
      if (exposition != null) formData.exposition = exposition;
      if (valueCommodite != null) {
        formData.valueCommodite = valueCommodite;
      }
      if (Livraison > 0) formData.Livraison = Livraison;

      if (commission != null) formData.commission = commission;
      if (zFiscale > 0) formData.zFiscale = zFiscale;
      if (valueDisponibiliteLots >= 0)
        formData.valueDisponibiliteLots = valueDisponibiliteLots;
      if (promoteur != null) formData.promoteur = promoteur;
      if (programme != null) formData.programme = programme;

      formData.perPage = perPage;
      formData.limit = limit;
      formData.page = page;

      return axios
        .get(apiCreditWiinUrl + "/get-immo", {
          headers: {
            "Content-Type": "application/json",
          },
          params: formData,
        })
        .then((response) => {
          state.ListeResultRechBienNeuf = [];
          state.totalBiens = 0;
          state.totalProgrammes = 0;

          let data = response.data.data.data;
          state.totalRowRechBienNeuf = response.data.data.total;
          state.totalProgrammes = response.data.tot_prog;
          state.totalBiens = response.data.biens;

          Object.keys(data).forEach((key) => {
            state.ListeResultRechBienNeuf.push(data[key]);
          });
          state.succes_result_bien_neuf = true;
        })
        .catch((e) => {
          state.error_result_bien_neuf = true;
        });
    },

    searchVilleByCP({ commit, state }, { query }) {
      return axios
        .get(
          apiCreditWiinUrl + "/location/find-city?zip_code=" + query,
          { headers: { "X-Requested-With": "XMLHttpRequest" } }
        )
        .then((response) => {
          const data = response.data;
          state.Location = [];
          state.Localisation = "";

          for (let i = 0; i < data.length; i++) {
            const select = {
              value: data[i].id,
              text: data[i].nom + " (" + data[i].codePostal + ")",
              codePostal: data[i].codePostal,
              searchText: data[i].nom,
            };
            state.Location.push(select);
          }
        })
        .catch((e) => {});
    },

    searchVilleByName({ commit, state }, { query }) {
      return axios
        .get(
          apiCreditWiinUrl + "/location/search-city?name=" + query,
          { headers: { "X-Requested-With": "XMLHttpRequest" } }
        )
        .then((response) => {
          const data = response.data;
          state.Location = [];
          state.Localisation = "";

          for (let i = 0; i < data.length; i++) {
            const select = {
              value: data[i].id,
              text: data[i].nom + " (" + data[i].codePostal + ")",
              codePostal: data[i].codePostal,
              searchText: data[i].nom,
            };
            state.Location.push(select);
          }
        })
        .catch((e) => {});
    },

    getPromoteurs({ commit, state }, { promoteur }) {
      return axios
        .get(apiUrl + "/promoteurs?promoteur=" + promoteur, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          state.listePromoteurs = [];
          const data = response.data;
          Object.keys(data).forEach((key) => {
            const select = {
              value: data[key].promoteur,
              text: data[key].promoteur,
            };
            state.listePromoteurs.push(select);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getProgrammes({ commit, state }, { programme }) {
      return axios
        .get(apiUrl + "/programmes?programme=" + programme, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          state.listeProgrammes = [];
          const data = response.data;
          Object.keys(data).forEach((key) => {
            const select = {
              value: data[key].titre_prog,
              text: data[key].titre_prog,
            };
            state.listeProgrammes.push(select);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getBienPrices({ commit, state }, { bien_id }) {
      return axios
        .get(apiUrl + "/api/bien-neuf-prices?bien_id=" + bien_id, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          state.Bien = [];
          state.Bien = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getAncienByID({ commit, state }, { id }) {
      return axios
        .get(apiUrl + "/api/get-immo/" + id, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          state.Bien = null;
          state.Bien = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getStatusBien({ commit, state }, { payload }) {
      return axios
        .post(apiUrl + "/api/status-bien", payload, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((res) => {
          state.statusBien = null;
          // console.log(res.data.status)
          state.statusBien = res.data.status;
        })
        .catch((err) => {});
    },

    getBienAncienFromMoteurImmo({ commit, state }, { data }) {
      state.ListeBienAncien = [];
      state.errorMessage = null;
      return axios
        .get(apiCreditWiinUrl + "/bien-ancien-moteur", {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Methods": "POST",
          },
          params: data,
        })
        .then((res) => {
          if (res.data.error) {
            state.errorMessage = res.data.error;
          } else {
            console.log("DATA LENGTH", res.data.ads.length);
            res.data.ads.forEach((element) => {
              state.ListeBienAncien.push({
                ...element,
                nbrShow: 4,
              });
            });
            // state.ListeBienAncien = res.data.ads
            state.totalAncien = res.data.count;
          }
        })
        .catch((err) => {});
    },

    getBienAncienById({ commit, state }, { id }) {
      axios.get(apiCreditWiinUrl + `/bien-ancien-details/` + id).then((res) => {
        state.DetailsAncienBien = res.data.ad;
      });
    },

    setProjectFiltersAncien({ commit, state }, { data, project_id }) {
      return axios
        .post(
          apiUrl + "/api/updateFilterAncien",
          { data: data, project_id: project_id },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          state.projectFilters = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getVentePartage({ commit, state }, { data }) {
      state.ListeBienAncien = [];
      return axios
        .get(apiUrl + "/api/vente-partage", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("authToken"),
          },
          params: data,
        })
        .then((res) => {
          res.data.ads.data.forEach((element) => {
            state.ListeBienAncien.push({
              ...element,
              nbrShow: 4,
            });
          });
          state.totalAncien = res.data.count;
        });
    },

    storeVentePartage({ commit, state }, { data }) {
      return axios
        .post(
          apiUrl + "/api/store-vente-partage",
          { data: data },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("authToken"),
            },
          }
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    removeVentePartage({ commit, state }, { data }) {
      return axios
        .post(
          apiUrl + "/api/remove-vente-partage",
          { data: data },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("authToken"),
            },
          }
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    storeDejaVisite({ commit, state }, { data, project_id }) {
      return axios
        .post(
          apiUrl + "/api/store-deja-visite?project_id=" + project_id,
          { data: data },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("authToken"),
            },
          }
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    removeDejaVisite({ commit, state }, { data, project_id }) {
      return axios
        .post(
          apiUrl + "/api/remove-deja-visite?project_id=" + project_id,
          { data: data },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("authToken"),
            },
          }
        )
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getDejaVisite({ commit, state }, { data, project_id }) {
      state.ListeBienAncien = [];
      return axios
        .get(apiUrl + "/api/deja-visite?project_id=" + project_id, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("authToken"),
          },
          params: data,
        })
        .then((res) => {
          res.data.ads.forEach((element) => {
            state.ListeBienAncien.push({
              ...element,
              nbrShow: 4,
            });
          });
          state.totalAncien = res.data.count;
        });
    },

    setBienToAvisValeur({ commit, state }, { data, project_id }) {
      return axios
        .get(apiCreditWiinUrl + "/bien-to-avis-valeur/" + project_id, {
          headers: {
            "Content-Type": "application/json",
          },
          params: { data: data },
        })
        .then((res) => {})
        .catch((err) => {
          console.log(err);
        });
    },

    getMontantTotaleProjet({ commit, state }, { data, type }) {
      let result = 0;

      if (type == 1) {
        result =
          parseFloat(data.terrain) +
          parseFloat(data.viabilisation) +
          parseFloat(data.etablissement) +
          parseFloat(data.agence) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 1) {
        result =
          parseFloat(data.viabilisation) +
          parseFloat(data.logemet) +
          parseFloat(data.traveaux) +
          parseFloat(data.mobilier) +
          parseFloat(data.etablissement) +
          parseFloat(data.expertise) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 2) {
        result =
          parseFloat(data.terrain) +
          parseFloat(data.viabilisation) +
          parseFloat(data.logemet) +
          parseFloat(data.traveaux) +
          parseFloat(data.mobilier) +
          parseFloat(data.etablissement) +
          parseFloat(data.expertise) +
          parseFloat(data.agence) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) -
          parseFloat(data.apport);
      } else if (type == 3) {
        result =
          parseFloat(data.terrain) +
          parseFloat(data.viabilisation) +
          parseFloat(data.logemet) +
          parseFloat(data.traveaux) +
          parseFloat(data.mobilier) +
          parseFloat(data.etablissement) +
          parseFloat(data.expertise) +
          parseFloat(data.agence) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 4) {
        result =
          parseFloat(data.logemet) +
          parseFloat(data.traveaux) +
          parseFloat(data.mobilier) +
          parseFloat(data.etablissement) +
          parseFloat(data.agence) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 5) {
        result =
          parseFloat(data.logemet) +
          parseFloat(data.traveaux) +
          parseFloat(data.mobilier) +
          // parseFloat(data.etablissement) +
          parseFloat(data.agence) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 6) {
        result =
          parseFloat(data.logemet) +
          parseFloat(data.mobilier) +
          parseFloat(data.etablissement) +
          parseFloat(data.expertise) +
          parseFloat(data.agence) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 7) {
        result =
          parseFloat(data.logemet) +
          parseFloat(data.traveaux) +
          parseFloat(data.mobilier ? data.mobilier : 0) +
          parseFloat(data.etablissement) +
          parseFloat(data.expertise) +
          parseFloat(data.agence) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 8) {
        result =
          parseFloat(data.traveaux) +
          parseFloat(data.mobilier) +
          parseFloat(data.etablissement) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 9) {
        result =
          parseFloat(data.traveaux) +
          parseFloat(data.etablissement) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 10 || type == 11) {
        result =
          parseFloat(data.traveaux) +
          parseFloat(data.etablissement) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 12) {
        result =
          parseFloat(data.etablissement) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 13) {
        result =
          parseFloat(data.soulte) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 14) {
        result =
          parseFloat(data.soulte) +
          parseFloat(data.traveaux) +
          parseFloat(data.crd_refinance) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 15) {
        result =
          parseFloat(data.etablissement) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      } else if (type == 16 || type == 17) {
        result =
          parseFloat(data.tresorie) +
          parseFloat(data.pret_rachete) +
          parseFloat(data.decouvert_blanc) +
          parseFloat(data.traveaux) +
          parseFloat(data.indemite_ra) +
          parseFloat(data.fr_leve_hypo) +
          parseFloat(data.notaire) +
          parseFloat(data.courtage) -
          parseFloat(data.apport);
      }
      return Math.round(result);
    },

    getBienToAvisValeur({ commit, state }, { project_id }) {
      state.liste_avis_valeur = [];
      return axios
        .get(apiCreditWiinUrl + "/liste-bien-to-avis-valeur/" + project_id, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          let response = res.data.split(",");
          response.forEach((element) => {
            state.liste_avis_valeur.push(element);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getProjectCosts({ commit, state }, { project_id }) {
      return axios
        .get(apiCreditWiinUrl + "/api/simulation/" + project_id + "/costs", {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Authorization: "Bearer " + localStorage.getItem("EmpToken"),
          },
        })
        .then((response) => {
          state.projectCost = response.data.data;
          localStorage.setItem(
            "projectCosts",
            JSON.stringify(state.projectCost)
          );
        });
    },

    updateProject({ commit, state }, { amount, project_id }) {
      let typeOperation = localStorage.getItem("typeOperation");
      return axios
        .get(
          apiCreditWiinUrl +
            "/api/fraisNotaire/taux?type=" +
            typeOperation +
            "&amount=" +
            amount,
          {
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Authorization: "Bearer " + localStorage.getItem("EmpToken"),
            },
          }
        )
        .then((response) => {
          state.projectCost.logemet = amount;
          const data = response.data[0];
          let tauxNotaire = 0;
          if (data["taux"] != undefined || data["taux"] != null) {
            tauxNotaire = data["taux"];
            state.projectCost.notaire = parseFloat(
              (amount / 100) * tauxNotaire
            ).toFixed(2);

            let result = 0;

            if (typeOperation == 1) {
              result =
                parseFloat(state.projectCost.terrain) +
                parseFloat(state.projectCost.viabilisation) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.agence) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 1) {
              result =
                parseFloat(state.projectCost.viabilisation) +
                parseFloat(state.projectCost.logemet) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.mobilier) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.expertise) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 2) {
              result =
                parseFloat(state.projectCost.terrain) +
                parseFloat(state.projectCost.viabilisation) +
                parseFloat(state.projectCost.logemet) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.mobilier) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.expertise) +
                parseFloat(state.projectCost.agence) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 3) {
              result =
                parseFloat(state.projectCost.terrain) +
                parseFloat(state.projectCost.viabilisation) +
                parseFloat(state.projectCost.logemet) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.mobilier) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.expertise) +
                parseFloat(state.projectCost.agence) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 4) {
              result =
                parseFloat(state.projectCost.logemet) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.mobilier) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.agence) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 5) {
              result =
                parseFloat(state.projectCost.logemet) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.mobilier) +
                // parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.agence) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 6) {
              result =
                parseFloat(state.projectCost.logemet) +
                parseFloat(state.projectCost.mobilier) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.expertise) +
                parseFloat(state.projectCost.agence) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 7) {
              result =
                parseFloat(state.projectCost.logemet) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(
                  state.projectCost.mobilier ? state.projectCost.mobilier : 0
                ) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.expertise) +
                parseFloat(state.projectCost.agence) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 8) {
              result =
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.mobilier) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 9) {
              result =
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 10 || typeOperation == 11) {
              result =
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 12) {
              result =
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 13) {
              result =
                parseFloat(state.projectCost.soulte) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 14) {
              result =
                parseFloat(state.projectCost.soulte) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.crd_refinance) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 15) {
              result =
                parseFloat(state.projectCost.etablissement) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            } else if (typeOperation == 16 || typeOperation == 17) {
              result =
                parseFloat(state.projectCost.tresorie) +
                parseFloat(state.projectCost.pret_rachete) +
                parseFloat(state.projectCost.decouvert_blanc) +
                parseFloat(state.projectCost.traveaux) +
                parseFloat(state.projectCost.indemite_ra) +
                parseFloat(state.projectCost.fr_leve_hypo) +
                parseFloat(state.projectCost.notaire) +
                parseFloat(state.projectCost.courtage) -
                parseFloat(state.projectCost.apport);
            }
            state.projectCost.couttotal = Math.round(result);
            localStorage.setItem(
              "projectCosts",
              JSON.stringify(state.projectCost)
            );
          }
        });
    },

    getBankIdents({ commit, state }) {
      state.bankIdents = [];
      return axios
        .get(apiCreditWiinUrl + "/api/banks/bank-idents", {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Authorization: "Bearer " + localStorage.getItem("EmpToken"),
          },
        })
        .then((response) => {
          //   console.log('bankIdents', response.data);
          state.bankIdents.push(response.data.data);
        })
        .catch((e) => {
          //Vue.$notify('error filled', 'Liste des banques vide', e, { duration: 5000, permanent: false });
        });
    },

    generatePropositionsBasicWithLoader(
      { commit, state },
      {
        type,
        bank_ident,
        duration,
        mensualite_souhaite,
        ti_souhaite,
        ta_souhaite,
      }
    ) {
      if (type == "basic") {
        //state.propostionsValidesBasic = [];
        //state.propositionsInvalidesBasic = [];
        state.propostionsValidesBasic = state.propostionsValidesBasic.filter(
          (item) => item.negocier == 1
        );
        state.propositionsInvalidesBasic = state.propositionsInvalidesBasic.filter(
          (item) => item.negocier == 1
        );
      }

      let i = 0;
      state.doneBasic = false;
      console.log("ident basic", bank_ident);
      var currentIdProjet = localStorage.getItem("project_id");

      function request() {
        state.loadingbankBasic = bank_ident[i];
        return axios
          .post(
            apiCreditWiinUrl +
              "/api/simulations/" +
              localStorage.getItem("project_id") +
              "/propositions",
            {
              type: type,
              bank_ident: bank_ident[i]["ident"],
              isFromImmoWiin: true,
              project_id: currentIdProjet,
              costs: state.projectCost,
              duration: duration,
              mensualite_souhaite: mensualite_souhaite,
              ti_souhaite: ti_souhaite,
              ta_souhaite: ta_souhaite,
            },
            {
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                Authorization: "Bearer " + localStorage.getItem("EmpToken"),
              },
            }
          )
          .then((response) => {
            if (response != undefined && response.data != undefined) {
              if (state.loadingValueBasic < 100) {
                state.loadingValueBasic += 100 / bank_ident.length;
              }
              if (currentIdProjet != localStorage.getItem("project_id")) {
                i = bank_ident.length;
              }

              if (response.data.inserted.data.length > 0) {
                let data = response.data.inserted.data;

                data.forEach(function(item) {
                  if (item.is_valid == true) {
                    state.propostionsValidesBasic.push(item);
                  } else if (item.is_valid == false) {
                    state.propositionsInvalidesBasic.push(item);
                  }
                });
              }
              if (response.data.unchanged.data.length > 0) {
                let data = response.data.unchanged.data;
                data.forEach(function(item) {
                  if (item.is_valid == true) {
                    state.propostionsValidesBasic.push(item);
                  } else if (item.is_valid == false) {
                    state.propositionsInvalidesBasic.push(item);
                  }
                });
              }
              if (response.data.updated.data.length > 0) {
                let data = response.data.updated.data;
                data.forEach(function(item) {
                  if (item.is_valid == true) {
                    state.propostionsValidesBasic.push(item);
                  } else if (item.is_valid == false) {
                    state.propositionsInvalidesBasic.push(item);
                  }
                });
              }
              i++;

              if (i >= bank_ident.length) {
                state.loadingbankBasic = "";
                state.doneBasic = true;
                state.propositionsInvalidesBasic = state.propositionsInvalidesBasic
                  .slice()
                  .sort((a, b) => a.bank_id - b.bank_id);
                state.propostionsValidesBasic = state.propostionsValidesBasic
                  .slice()
                  .sort((a, b) => a.bank_id - b.bank_id);

                let params = {
                  idPorjet: localStorage.getItem("project_id"),
                };
                // store.dispatch("getCurrentTacheBySimulation", params);
              } else {
                state.loadingValueBasic = 100 / bank_ident.length;
                request();
              }
            } else {
              i++;

              request();
            }
          })
          .catch((e) => {
            if (i <= bank_ident.length) {
              i++;
            }
          });
      }
      if (!state.doneBasic) {
        request();
      } else state.loadingbankBasic = "";
    },
  },
};
